import React from 'react';

export default class NotFound extends React.Component {
  render(){
    return(
      <div><h1>Página não encontrada</h1></div>
    );
  }
}
